import type { LinkGroup } from './types';
import { useAboutUsLinks } from './useAboutUsLinks';
import { useFollowUsLinks } from './useFollowUsLinks';
import { useGetInvolvedLinks } from './useGetInvolvedLinks';
import { useHelpLegalLinks } from './useHelpLegalLinks';
import { useLearnLinks } from './useLearnLinks';

export function useFooterLinks(): readonly LinkGroup[] {
	return [
		// force multi-line
		useGetInvolvedLinks(),
		useLearnLinks(),
		useAboutUsLinks(),
		useHelpLegalLinks(),
		useFollowUsLinks(),
	].filter((group) => !!group);
}

export type FooterLinkGroup = LinkGroup;
